import { all } from 'redux-saga/effects';

import fetch from './fetch';

export default function generateSagas(history) {
  return function* rootSaga() {
    yield all([...fetch(history)]);
  };
}
